import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-style-two',
  templateUrl: './about-style-two.component.html',
  styleUrls: ['./about-style-two.component.scss']
})
export class AboutStyleTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
